import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon } from 'lucide-react';
import { Divider } from './ui/Divider';
export function PromiseSection() {
  return <section className="bg-delux-bg py-20 px-4 sm:px-6 lg:px-8" data-id="element-240">
      <div className="max-w-3xl mx-auto text-center" data-id="element-241">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-242">
          <ShieldIcon className="w-16 h-16 text-delux-gold mx-auto mb-8" data-id="element-243" />
          <h2 className="font-heading text-3xl md:text-4xl text-delux-gold mb-8" data-id="element-244">
            Nuestra Promesa Para Ti
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="font-body text-lg md:text-xl text-delux-body leading-relaxed space-y-6" data-id="element-245">
          <p data-id="element-246">
            Si no sales de Barbershop Delux Cut viéndote y sintiéndote mejor que
            en cualquier otra barbería que hayas visitado — dínoslo. Lo
            corregiremos. Cada vez.
          </p>

          <p className="font-heading text-2xl text-delux-white font-bold py-4" data-id="element-247">
            Esa es la garantía Barbershop Delux Cut.
          </p>

          <p data-id="element-248">
            No nos interesan los clientes de una sola vez. Estamos construyendo
            relaciones con hombres que exigen más de su apariencia — y de su
            barbero.
          </p>
        </motion.div>
      </div>
      <Divider data-id="element-249" />
    </section>;
}